import React, { useState } from 'react';

import { KuposErrorSuccessModal } from '../../../common';
import CommonService from '../../../../services/commonService';

function LoggedInExtraCardsSection(props) {
  const [showSuccessFailureModal, setShowSuccessFailureModal] = useState(null);
  const [showSuccessFailureModalStatus, setShowSuccessFailureModalStatus] = useState(null);
  const [showSuccessFailureModalBodyText, setShowSuccessFailureModalBodyText] = useState(null);

  const isNoIconSelected = () => {
    let isActive = props.extraSections.find(it => it.active);
    return isActive ? true : false;
  };

  const onSelectionChange = key => {
    if (key === 0 || key === 1) {
      document.getElementById('sub-details-section-my-account').scrollIntoView();
      if (props.profileData && props.profileData.identity_type != 7) {
        setShowSuccessFailureModal(true);
        setShowSuccessFailureModalStatus(false);
        setShowSuccessFailureModalBodyText(props.t('PROFILE.FUNCTIONALITY_FOR_RUT'));

        return;
      }
    }
    if (key === 2) {
      props.history.push('/');
      return;
    }
    props.onSelectionChange(key);
  };

  const { t } = props;
  return (
    <div className="logged-in-extra-cards-section">
      {/* <div className="logged-in-section-title font13">
        {t('PROFILE.MY_TRANSACTIONS_BOLD.NORMAL')}
        <span className="bold-text">&nbsp;{t('PROFILE.MY_TRANSACTIONS_BOLD.BOLD')}</span>
      </div> */}

      <div className="logged-in-extra-cards font10">
        {props.extraSections.map((val, key) => (
          <div
            key={key}
            className="kupos-card logged-in-side-card pointer"
            onClick={() => props.operator && props.operator.is_pay_enabled ? onSelectionChange(key): null}
            style={{
              backgroundColor: val.backgroundColor,
              color: val.textColor,
              marginRight: '20px',
            }}
          >
            <div>
              <img src={val.active || !isNoIconSelected() ? val.iconActive : val.icon} alt="" />
            </div>
            <div className="icon-label">
              <span className="bold-text">{t('PROFILE.' + val.name)}</span>
            </div>
          </div>
        ))}
      </div>

      <KuposErrorSuccessModal
        showModal={showSuccessFailureModal}
        onHide={() => {
          setShowSuccessFailureModal(false);
          setShowSuccessFailureModalStatus(false);
        }}
        onButtonClick={() => {
          setShowSuccessFailureModal(false);
          setShowSuccessFailureModalStatus(false);
        }}
        success={showSuccessFailureModalStatus}
        bodyText={showSuccessFailureModalBodyText}
        t={props.t}
        operator={props.operator}
      />
    </div>
  );
}

export default LoggedInExtraCardsSection;

// export default class LoggedInExtraCardsSection extends Component {
//   static propTypes = {
//     extraSections: PropTypes.array.isRequired,
//     profileData: PropTypes.object,
//     onSelectionChange: PropTypes.func,
//     t: PropTypes.func,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   isNoIconSelected = () => {
//     let isActive = this.props.extraSections.find(it => it.active);
//     return isActive ? true : false;
//   };

//   onSelectionChange = key => {
//     document.getElementById('sub-details-section-my-account').scrollIntoView();
//     // document.getElementById('logged-in-extra-cards-section').scrollIntoView();
//     if (key === 0 || key === 1) {
//       if (this.props.profileData && this.props.profileData.identity_type != 7) {
//         this.setState({
//           showSuccessFailureModal: true,
//           showSuccessFailureModalStatus: false,
//           showSuccessFailureModalBodyText: this.props.t('PROFILE.FUNCTIONALITY_FOR_RUT'),
//         });
//         return;
//       }
//     }
//     this.props.onSelectionChange(key);
//   };

//   render() {
//     const { t } = this.props;
//     return (
//       <div className="logged-in-extra-cards-section">
//         <div className="logged-in-section-title font13">
//           {t('PROFILE.MY_TRANSACTIONS_BOLD.NORMAL')}
//           <span className="bold-text">&nbsp;{t('PROFILE.MY_TRANSACTIONS_BOLD.BOLD')}</span>
//         </div>

//         <div className="logged-in-extra-cards font10">
//           {this.props.extraSections.map((val, key) => (
//             <div
//               key={key}
//               className="kupos-card logged-in-side-card pointer"
//               onClick={() => this.onSelectionChange(key)}
//             >
//               <div>
//                 <img
//                   src={val.active || !this.isNoIconSelected() ? val.iconActive : val.icon}
//                   alt=""
//                 />
//               </div>
//               <div className="icon-label">
//                 <span className="bold-text">{t('PROFILE.' + val.name)}</span>
//               </div>
//             </div>
//           ))}
//         </div>

//         <KuposErrorSuccessModal
//           showModal={this.state.showSuccessFailureModal}
//           onHide={() =>
//             this.setState({ showSuccessFailureModal: false, showSuccessFailureModalStatus: false })
//           }
//           onButtonClick={() =>
//             this.setState({ showSuccessFailureModal: false, showSuccessFailureModalStatus: false })
//           }
//           success={this.state.showSuccessFailureModalStatus}
//           bodyText={this.state.showSuccessFailureModalBodyText}
//           t={this.props.t}
//         />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/themes/my-account/LoggedInExtraCardsSection/LoggedInExtraCardsSection.js